import authAxios from "../axios-instance/authAxios";

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST;

export const ProposalApi = {
    getProposals,
    updateProposal,
    deleteProposal,
    updateProposalSettings,
}

async function getProposals({ headers, params }) {
    return await authAxios.get(`${MAIN_API_HOST}/v2/public/proposals`, {
        headers: headers,
        params: params,
    })
}

async function updateProposal({ headers, id, body }) {
    return await authAxios.patch(`${MAIN_API_HOST}/v2/public/proposals/${id}`, body, {
        headers: headers,
    })
}

async function deleteProposal({ headers, id }) {
    return await authAxios.delete(`${MAIN_API_HOST}/v2/public/proposals/${id}`, {
        headers: headers,
    })
}

async function updateProposalSettings({ headers, body }) {
    return await authAxios.patch(`${MAIN_API_HOST}/v2/public/proposal-settings`, body, {
        headers: headers,
    })
}
